<template>
  <div class="loginPage">
    <div class="topBar">
      <img :src="back" alt="" @click="fetchBack" v-show="backShow">
    </div>
    <div class="loginLogo">
      <img :src="loginLogo" alt=""/>
    </div>
    <div class="liveChat" @click="handleOpenChat"><img :src="liveChat" alt=""></div>
    <div class="toGame" @click="toGameDemo"><img :src="game" alt=""></div>
    <div class="loginBanner"><img :src="loginBanner" alt=""/></div>
    <div class="permit"><img :src="permit" alt=""></div>
    <div class="loginContainer">
      <div class="login" v-if="this.$store.state.loginStatus === 'login'">
        <div class="title">
          <img src="../../assets/images/login/mobileIcon.svg" class="mobileIcon" alt="">
          {{ $t('lang.setting.mobile') }}</div>
        <div class="input">
          <div class="selectInput" @click="showPopup = true">
            <span>+{{ countryCode }}</span>
            <img style="margin-left: 2vw;width: 3.611vw" :src="dropDown" alt=""/>
          </div>
          <input type="number" style="width: 61.667vw" v-model="tel" @input="limitInputLength('tel',20)">
          <div class="err" v-if="showErr">
            {{ $t('lang.login.invalid') }}
          </div>
        </div>
        <div class="title">{{ $t('lang.login.otp') }}</div>
        <div class="input">
          <input type="number" v-model="sns" @input="limitInputLength('sns',8)">
          <div :class="countdown === 0&&tel&&(picSwitch&&pictureCode||!picSwitch) ? 'resend' : 'wait'"
               @click="getSns">
            {{ $t('lang.login.sendOtp') }}{{ countdown > 0 ? `(${countdown}s)` : '' }}
          </div>
        </div>
        <div class="otpTip" style="font-size: 3.333vw;font-weight: 400;font-family: 'Inter';color: #fff;letter-spacing: 0.3vw;padding-bottom: 2vw">{{ $t('lang.login.otpTip') }}</div>
        <div class="title" v-if="picSwitch&&countdown <= 0">{{ $t('lang.login.captcha') }}</div>
        <div class="input" v-if="picSwitch&&countdown <= 0">
          <input type="text" v-model="pictureCode" maxlength="4">
          <div class="picBtn" @click="initPicture">
            <img :src="codePicture" alt=""
                 style="padding-top: 7px;background-color: #BDB0B0;height: 100%;"/>
          </div>
        </div>
      </div>
      <div class="login" v-if="this.$store.state.loginStatus === 'register'">
        <div class="caption">
          {{ $t('lang.login.username') }}
        </div>
        <div class="input">
          <label>
            <input type="text" v-model="userName">
          </label>
          <div class="err" v-if="showErr">
            {{ $t('lang.login.invalid') }}
          </div>
        </div>
        <div class="caption">
          {{ $t('lang.login.depositCur') }}
        </div>
        <div class="input">
          <div class="selectInput" style="width: 100%" @click="showPopup = true">
            {{ currency }}&nbsp;{{ fetchCurrency[currency] }}
          </div>
        </div>
        <div class="caption" style="margin-top: 10px" v-if="!cid || !cid.startsWith('app')">
          {{ $t('lang.login.couponCode') }}
        </div>
        <div class="input">
          <label v-if="!cid">
            <input type="text" v-model="couponCode">
          </label>
          <label v-else-if="cid && !cid.startsWith('app')">
            <input type="text" v-model="couponCode" readonly>
          </label>
        </div>
      </div>
      <div class="btn">
        <div
          :class="hasSendOtp&&((codePicture&&tel&&sns&&pictureCode)||(!codePicture&&tel&&sns)) ? 'submit' : 'disabled'"
          @click="fetchSubmit">
          {{ $t('lang.common.submit') }}
        </div>
      </div>
      <GoogleLogin :LoginMethod="LoginByGoogle"/>
    </div>
    <Popup
      v-model='showPopup'
      position='bottom'>
      <Picker
        :slots="this.$store.state.loginStatus === 'login' ? countryCodeSlots : currencySlots"
        :showToolbar="true"
        @change="onValueChange">
        <span @click="showPopup = false">Done</span>
      </Picker>
    </Popup>
    <div class="inactive" v-if="showInactive">
      <div class="close"><img class="close" :src="close" alt="fork" @click="showInactive = false"/></div>
      <div class="ban">
        <img :src="ban" alt="ban"/>
      </div>
      <div class="tips">
        {{ $t('lang.login.abnormalPrompt1') }}<br><br>{{ $t('lang.login.abnormalPrompt5') }}
        <a href="mailto:support@pgebet.com">support@pgebet.com</a> {{ $t('lang.login.abnormalPrompt2') }}
        <a href="javascript:void(0)" @click="handleOpenChat">{{ $t('lang.login.abnormalPrompt3') }}</a>
        {{ $t('lang.login.abnormalPrompt4') }}
      </div>
      <div class="liveButton" @click="handleOpenChat">{{ $t('lang.support.customerService') }}</div>
    </div>
  </div>
</template>
<script>
import back from '@/assets/images/common/back.svg'
import permit from '@/assets/images/common/sharePermit.png'
import liveChat from '@/assets/images/common/liveChat.png'
import game from '@/assets/images/common/game.png'
import dropDown from '@/assets/images/login/dropDown.svg'
import ban from '@/assets/images/login/ban.png'
import close from '@/assets/images/login/close.png'
import cellPhone1 from '@/assets/images/login/cell_phone_1.svg'
import loginBanner from '@/assets/images/login/loginBanner.webp'
import loginLogo from '@/assets/images/login/loginLogo.png'
import cellPhone2 from '@/assets/images/login/cell_phone_2.svg'
import loginProgress from '@/assets/images/login/IN-login-progrss.png'
import {Popup, Picker, Toast} from 'mint-ui'
import request from '@/service'
import {LogUtils, afListener, fbListener, adListener} from '@/utils'
import store from '../../store/store'
import {fetchCurrency, InternationCurrency} from '@/constant'
import {mapMutations} from 'vuex'
import GoogleLogin from '@/components/GoogleAuth/index'

export default {
  name: 'Login',
  data () {
    return {
      ban,
      close,
      back,
      permit,
      loginLogo,
      loginBanner,
      liveChat,
      game,
      dropDown,
      cellPhone1,
      cellPhone2,
      loginProgress,
      backShow: false,
      slogan: '',
      countryCode: '',
      tel: '',
      picSwitch: false, // 图形验证开关
      pictureCode: '', // 验证码
      codePicture: '', // 图形
      inviteCode: '',
      sns: '',
      userName: '',
      currency: 'INR',
      showPopup: false,
      countryCodeSlots: [
        {
          flex: 1,
          values: [
            'India +91',
            'Vietnam +84',
            'Australia +61',
            'New Zealand +64',
            'UAE +971'
          ],
          textAlign: 'center'
        }
      ],
      currencySlots: [
        {
          flex: 1,
          values: [
            'INR ₹'
            /* 'USD $',
            'EUR €',
            'CNY ￥' */
          ],
          textAlign: 'center'
        }
      ],
      fetchCurrency,
      InternationCurrency,
      loginStatus: this.$store.state.loginStatus,
      showErr: false,
      showInactive: false,
      email: '',
      password: '',
      emailReg: RegExp(/^(.+)@(.+)$/),
      passwordReg: RegExp(/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{8,18}$/),
      couponCode: localStorage.getItem('cid'),
      cid: localStorage.getItem('cid'),
      fromRoute: '',
      countdown: 0,
      visitorCode: '',
      hasSendOtp: false
    }
  },
  components: {
    GoogleLogin,
    Popup,
    Picker
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log(from)
      if (from.name === 'Earn') {
        LogUtils.saveUserEventParams('inviteFromToLogin')
      }
      vm.fromRoute = from.name
      vm.setLoginStatus('login')
    })
  },
  async mounted () {
    // #948 渠道用户注册流程 未登录不让进home页
    if (!this.cid || !this.$store.state.toShareCid.includes(this.cid)) {
      this.backShow = true
    }
    this.visitorCode = await LogUtils.getVisitorCode()
    this.initPicture()
    this.saveEvent('firstLoginPage')
    this.slot = this.countryCodeSlot
    this.currencySlots[0].values = InternationCurrency.getCurrency(this.$store.state.internation)
    this.shareType = localStorage.getItem('shareType')
    this.inviteCode = localStorage.getItem('shareCode') ? localStorage.getItem('shareCode') : null
  },
  methods: {
    ...mapMutations({
      setInternation: 'setInternation',
      setInternationName: 'setInternationName',
      setLocale: 'setLocale',
      setLoginStatus: 'setLoginStatus'
    }),
    saveEventNotOnce (eventName, userId) {
      const param1 = window.Android ? 1 : 0
      const param2 = {
        VisitorCode: this.visitorCode
      }
      LogUtils.saveUserEventParams(eventName, userId, param1, JSON.stringify(param2), localStorage.getItem('cid'))
    },
    saveEvent (eventName) {
      const eventStore = localStorage.getItem(eventName)
      if (!eventStore && this.visitorCode) {
        const param1 = window.Android ? 1 : 0
        const param2 = {
          VisitorCode: this.visitorCode
        }
        LogUtils.saveUserEventParams(eventName, '', param1, JSON.stringify(param2))
        localStorage.setItem(eventName, new Date().getTime())
      }
    },
    LoginByGoogle (googleId, mail) {
      let cid = localStorage.getItem('cid')
      let data = {
        email: mail,
        GoogleId: googleId,
        countryCode: this.countryCode,
        currencyName: this.countryCode === '91' ? 'INR' : 'BRL',
        campaignId: cid,
        shareCode: this.inviteCode,
        visitorCode: this.visitorCode,
        internation: this.$store.state.internation,
        device: window.Android ? 1 : 0
      }
      let VIRdataStr = localStorage.getItem('shareVIRData')
      let VIRdata = null
      if (VIRdataStr) {
        VIRdata = JSON.parse(VIRdataStr)
      }
      if (VIRdata) {
        data.campaignId = VIRdata.cid
        data.VirShare = 'VIR'
      }
      const url = '/innovation/account/register/from/googleid'
      request('post', url, data).then(res => {
        if (res.Code === 0) {
          localStorage.setItem('fromRegister', 1)
          localStorage.setItem('userInfo', JSON.stringify({...res}))
          if (!localStorage.getItem('cid') && !res.CampaignId && cid) {
            localStorage.setItem('cid', cid)
          }
          if (res.CampaignId) {
            localStorage.setItem('cid', res.CampaignId)
          }
          const param3 = localStorage.getItem('utm_source')
          const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
          if (param3 !== null) {
            const param2 = this.visitorCode
            LogUtils.saveUserEventParams('utm_source_register', userInfo.UserId, 0, param2, param3)
          }
          // 谷歌注册埋点
          if (res.GoogleRegister && res.GoogleRegister === 1) {
            adListener('Register')
            this.saveEventNotOnce('googleRegister', userInfo.UserId)
          } else {
            adListener('Login')
          }
          setTimeout(() => {
            this.$router.push({path: '/Home', query: {}})
          }, 500)
        } else if (res.Code === 3) {
          Toast(this.$t('lang.loginError.error03'))
          this.setLoginStatus('login')
        } else if (res.Code === 2) {
          Toast(this.$t('lang.loginError.error02'))
          this.setLoginStatus('login')
        } else if (res.Code === 10100) {
          Toast(this.$t('lang.loginError.error10100'))
          this.setLoginStatus('login')
        } else if (res.Code === 60002) {
          Toast(this.$t('lang.loginError.error60002'))
          this.vCode = ''
          this.sessionCode = ''
          this.getValidateCodeImg()
          this.setLoginStatus('login')
        } else if (res.Code === 60001) {
          Toast(this.$t('lang.loginError.error60001'))
          this.vCode = ''
          this.sessionCode = ''
          this.getValidateCodeImg()
          this.setLoginStatus('login')
        } else if (res.Code === 10001) {
          Toast(this.$t('lang.loginError.error10001'))
          this.setLoginStatus('login')
        } else if (res.Code === 10002) {
          Toast(this.$t('lang.login.toast10002'))
          this.setLoginStatus('login')
        } else if (res.Code === 10042) {
          Toast(this.$t('lang.loginError.error10042'))
          this.setLoginStatus('login')
        } else if (res.Code === 10043) {
          Toast(this.$t('lang.loginError.error10043'))
          this.setLoginStatus('login')
        } else if (res.Code === 10051) {
          Toast(this.$t('lang.loginError.error10051'))
          this.setLoginStatus('login')
        } else if (res.Code === 10044) {
          Toast(this.$t('lang.loginError.error10044'))
          this.setLoginStatus('login')
        } else if (res.Code === 10053) {
          Toast(this.$t('lang.loginError.error10053'))
          this.setLoginStatus('login')
        } else if (res.Code === 10059) {
          Toast(this.$t('lang.loginError.error10059'))
          this.setLoginStatus('login')
        } else if (res.Code === 10052) {
          Toast('GoogleId already exists!')
          this.setLoginStatus('login')
        } else if (res.Code === 10054) {
          Toast('FacebookId already exists!')
          this.setLoginStatus('login')
        } else if (res.Code === 10060) {
          Toast(this.$t('lang.loginError.error10060'))
          this.setLoginStatus('login')
        } else if (res.Code === 10111) {
          Toast(this.$t('lang.login.toast10111'))
          this.setLoginStatus('login')
        } else if (res.Code === 10122) {
          Toast(this.$t('lang.login.toast10122'))
          this.setLoginStatus('login')
        }
      }).catch(err => {
        Toast('Fail')
        console.log(err)
      })
    },
    limitInputLength (mode, maxLength) {
      if (mode === 'tel' && this.tel.length > maxLength) {
        this.tel = this.tel.slice(0, maxLength) // 如果超过最大长度，截断输入
      } else if (mode === 'sns' && this.sns.length > maxLength) {
        this.sns = this.sns.slice(0, maxLength) // 如果超过最大长度，截断输入
      } else if (mode === 'sns' && this.sns.length === 4 && this.hasSendOtp && ((this.codePicture && this.tel && this.sns && this.pictureCode) || (!this.codePicture && this.tel && this.sns))) {
        this.saveEventNotOnce('autoSubmit', '')
        this.fetchSubmit()
      }
    },
    toGameDemo () {
      sessionStorage.setItem('gameType', 'demo')
      this.$router.push('Home')
      // saveUserEventParams
      LogUtils.saveUserEventParams('goGameOfTypeDemoFromLogin')
    },
    handleOpenChat () {
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
    },
    initPicture () {
      const url = '/innovation/account/get/rvc'
      const data = {SessionCode: this.visitorCode}
      request('post', url, data).then(res => {
        if (res) {
          this.picSwitch = res.Switch
          this.codePicture = res.Image
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onValueChange (picker, value) {
      if (this.$store.state.loginStatus === 'login') {
        this.countryCode = value[0].split('+')[1]
      } else {
        this.currency = value[0].split(' ')[0]
      }
    },
    isSameDay (timestamp1, timestamp2) {
      // 将时间戳转换为 Date 对象
      const date1 = new Date(timestamp1)
      const date2 = new Date(timestamp2)

      // 比较年、月、日是否相同
      const isSameYear = date1.getFullYear() === date2.getFullYear()
      const isSameMonth = date1.getMonth() === date2.getMonth()
      const isSameDay = date1.getDate() === date2.getDate()

      // 如果年、月、日都相同，则表示在同一天
      return isSameYear && isSameMonth && isSameDay
    },
    countdownTimer () {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1
          this.countdownTimer()
        }, 1000)
      } else if (this.countdown === 0) {
        this.initPicture()
        this.pictureCode = ''
      }
    },
    fetchSubmit () {
      store.commit('setFromLoggedIn', true) // 2022-10-08 HHY 设置来自登录页面
      switch (this.$store.state.loginStatus) {
        case 'login':
          if (!this.tel) {
            Toast(this.$t('lang.login.invalid'))
            return
          }
          if (!this.sns) {
            // this.showErr = true
            Toast(this.$t('lang.login.incorrectCode'))
            return
          }
          if (!this.hasSendOtp) {
            Toast(this.$t('lang.login.incorrectCode'))
            return
          }
          this.login()
          break
        case 'register':
          this.register()
          break
      }
    },
    getSns () {
      if (this.countdown > 0) {
        Toast(this.$t('lang.login.tooOften').replace('{seconds}', this.countdown))
        return
      }
      if (!this.tel) {
        Toast(this.$t('lang.login.invalid'))
        return
      }
      if (this.picSwitch && !this.pictureCode) {
        Toast('Invalid captcha!')
        return
      }
      this.hasSendOtp = true
      // 发送OTP埋点
      const param1 = window.Android ? 1 : 0
      LogUtils.saveUserEventParams('otpClick', '', param1, '{visitorCode:' + this.visitorCode + '}')
      const url = '/innovation/account/sendsns'
      const data = {
        SnsCode: this.pictureCode,
        mobile: this.tel,
        countryCode: this.countryCode,
        visitorCode: this.visitorCode,
        campaignId: localStorage.getItem('cid'),
        inviteCode: this.inviteCode // 2022-12-20 HHY
      }
      request('post', url, data).then(res => {
        this.sns = ''
        switch (res.Code) {
          case 10111:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.pictureCode = ''
            this.initPicture()
            if (res.Message) {
              Toast(this.$t('lang.login.toast10111') + res.Message)
            } else {
              Toast(this.$t('lang.login.toast10111'))
            }
            break
          case 10122:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.pictureCode = ''
            this.initPicture()
            if (res.Message) {
              Toast(this.$t('lang.login.toast10122') + res.Message)
            } else {
              Toast(this.$t('lang.login.toast10122'))
            }
            break
          case 10002:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.pictureCode = ''
            this.initPicture()
            if (res.Message) {
              Toast(this.$t('lang.login.toast10002') + res.Message)
            } else {
              Toast(this.$t('lang.login.toast10002'))
            }
            break
          case 10003:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            this.showInactive = true
            this.pictureCode = ''
            this.initPicture()
            break
          case 90005:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('Invite Code input is invalid.')
            this.pictureCode = ''
            this.initPicture()
            break
          case 90006:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('The OTP code has been exhausted, please register again tomorrow.')
            this.pictureCode = ''
            this.initPicture()
            break
          case 90007:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('Message doesn’t send successfully, please try once again.')
            this.pictureCode = ''
            this.initPicture()
            break
          case 60002:
            LogUtils.saveUserEventParams('sendSnsError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
            Toast('Invalid captcha!')
            this.pictureCode = ''
            this.initPicture()
            break
          default:
            this.countdown = 60
            this.countdownTimer()
            this.sns = res.CodeForTestOnly
        }
      }).catch(() => {
        LogUtils.saveUserEventParams('sendSnsError', '', -1, '{visitorCode:' + this.visitorCode + '}')
        if (this.picSwitch) {
          this.pictureCode = ''
          this.initPicture()
        }
        Toast('Fail')
      })
    },
    /****
     * 2021-08-04 C007 注册成功重设7天Gift和24小时充值送弹框状态
     */
    login () {
      const url = '/innovation/account/login'
      const data = {
        mobile: this.tel,
        countryCode: this.countryCode,
        snsCode: this.sns,
        visitorCode: this.visitorCode,
        campaignId: localStorage.getItem('cid')
      }
      request('post', url, data).then(res => {
        if (res.Code === 1) {
          localStorage.setItem('userInfo', JSON.stringify({
            ...data,
            ...res
          }))
          try { // START 2022-02-09 CHP 设置CampaignId
            localStorage.setItem('cid', res.CampaignId)
            // END 2022-02-09 CHP 设置CampaignId
          } catch (e) {
          }
          afListener('Login')
          adListener('Login')
          fbListener('Login')
          this.fetchNext()
        } else if (res.Code === 3) {
          Toast(this.$t('lang.login.codeExpired'))
          LogUtils.saveUserEventParams('LoginError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
          this.setLoginStatus('login')
        } else if (res.Code === 4) {
          Toast(this.$t('lang.login.invalidCode'))
          LogUtils.saveUserEventParams('LoginError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
          this.setLoginStatus('login')
        } else if (res.Code === 10111) {
          Toast(this.$t('lang.login.toast10111'))
          LogUtils.saveUserEventParams('LoginError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
          this.setLoginStatus('login')
        } else if (res.Code === 10122) {
          LogUtils.saveUserEventParams('LoginError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
          Toast(this.$t('lang.login.toast10122'))
          this.setLoginStatus('login')
        } else if (res.Code === 10003) {
          LogUtils.saveUserEventParams('LoginError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
          this.showInactive = true
        } else {
          this.register()
        }
      }).catch((err) => {
        console.log(err)
        LogUtils.saveUserEventParams('LoginError', '', 'error', '{visitorCode:' + this.visitorCode + '}')
        Toast(this.$t('lang.common.fail'))
      })
    },
    /****
     * 2024-09-13 YTW 限制绑定下级机制
     */
    register () {
      let cid = localStorage.getItem('cid')
      const username = LogUtils.generateUUID().replace(/-/g, '')
      const url = '/innovation/account/register'
      let data = {
        mobile: this.tel,
        countryCode: this.countryCode,
        userName: username,
        currencyName: this.currency,
        campaignId: cid,
        snsCode: this.sns,
        shareCode: this.inviteCode,
        visitorCode: this.visitorCode,
        shareType: this.shareType ? this.shareType : '',
        internation: this.$store.state.internation
      }
      let VIRdataStr = localStorage.getItem('shareVIRData')
      let VIRdata = null
      if (VIRdataStr) {
        VIRdata = JSON.parse(VIRdataStr)
      }
      if (VIRdata) {
        data.campaignId = VIRdata.cid
        data.VirShare = 'VIR'
      }
      request('post', url, data).then(res => {
        if (res.CreateInviteCode === -19 || res.CreateInviteCode === -1) { // 请勿邀请自己的账号作为下线
          Toast(this.$t('lang.message.BindingFailed'))
          setTimeout(() => {
            this.regNext(res, cid)
          }, 1000)
        } else if (res.Code === 10111) {
          Toast(this.$t('lang.login.toast10111'))
        } else if (res.Code === 10122) {
          Toast(this.$t('lang.login.toast10122'))
        } else {
          if (VIRdata) {
            localStorage.setItem('VIRRegisterSuccess', true)
          }
          this.regNext(res, cid)
        }
      }).catch(() => {
        Toast(this.$t('lang.message.registerFail'))
      })
    },
    regNext (res, cid) {
      if (res.Code === 0) {
        localStorage.setItem('fromRegister', 1)
        this.inviteCode = ''
        localStorage.setItem('userInfo', JSON.stringify({
          UserName: this.userName,
          mobile: this.tel,
          ...res
        }))
        if (!localStorage.getItem('cid') && !res.CampaignId && cid) {
          localStorage.setItem('cid', cid)
        }
        if (res.CampaignId) {
          localStorage.setItem('cid', res.CampaignId)
        }
        const param3 = localStorage.getItem('utm_source')
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (param3 !== null) {
          const param2 = this.visitorCode
          LogUtils.saveUserEventParams('utm_source_register', userInfo.UserId, 0, param2, param3)
        }
        this.saveEventNotOnce('register', userInfo.UserId)
        adListener('Register')
        afListener('Register')
        fbListener('Register')
        this.fetchNext()
      } else {
        LogUtils.saveUserEventParams('RegisterError', '', res.Code, '{visitorCode:' + this.visitorCode + '}')
        if (res.Code === 10000) {
          Toast(this.$t('lang.message.usernameExit'))
        } else if (res.Code === 10001) {
          Toast(this.$t('lang.message.mobileExit'))
        } else if (res.Code === 60001) {
          Toast(this.$t('lang.login.codeExpired'))
        } else if (res.Code === 60002) {
          Toast(this.$t('lang.login.codeExpired'))
        } else {
          Toast(this.$t('lang.message.registerFail'))
        }
      }
    },
    fetchBack () {
      if (this.fromRoute === 'Share' || this.fromRoute === 'Promotion' || this.fromRoute === 'Support' || this.fromRoute === 'Earn' || this.fromRoute === 'ShareFiesta') {
        this.$router.go(-1)
      } else {
        this.$router.push('/Home')
      }
    },
    fetchNext () {
      if (this.fromRoute === 'Promotion' || this.fromRoute === 'Support' || this.fromRoute === 'Earn' || this.fromRoute === 'ShareFiesta') {
        this.$router.go(-1)
      } else {
        this.$router.push('/Home')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.loginPage {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;

  .topBar {
    position: relative;
    top: 5.277vw;
    left: 6.988vw;
    z-index: 1;
  }

  .background {
    position: absolute;
    top: 0;
    width: 100vw;
    z-index: 0;

    img {
      width: 100%;
    }
  }

  .permit {
    position: absolute;
    top: 188.333vw;
    left: 50%;
    transform: translate(-50%);
    width: 38.695vw;
    height: 13.333vw;
    padding-bottom: 5vw;

    img {
      width: 100%;
      height: 100%
    }
  }
  .toGame {
    position: absolute;
    top: 5vw;
    right: 7.96vw;
    width: 8.161vw;
    height: 6.111vw;
    z-index: 999;

    img {
      width: 100%;
      height: 100%
    }
  }
  .liveChat {
    position: absolute;
    top: 5vw;
    right: 20.96vw;
    width: 7.594vw;
    height: 7.222vw;
    z-index: 999;

    img {
      width: 100%;
      height: 100%
    }
  }

  .loginBanner {
    position: relative;
    top: 22vw;
    left: 50%;
    transform: translate(-50%);
    width: 89.844vw;
    height: 34.722vw;
    border-radius: 1.388vw;

    img {
      width: 100%;
    }
  }

  .loginLogo {
    position: absolute;
    top: 5.277vw;
    left: 16vw;
    width: 19.294vw;
    height: 11.666vw;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 25vw;
      height: auto;
    }
  }

  .loginContainer {
    position: absolute;
    top: 68.5vw;
    left: 50%;
    width: 85.277vw;
    transform: translate(-50%);

    .login {
      color: #E2C38F;
      height: max-content;

      .desc {
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        margin-bottom: 10px;
        color: #8c939d;
      }

      .title {
        font-family: Inter;
        position: relative;
        width: 100%;
        font-size: 4.444vw;
        font-weight: 400;
        text-align: left;
        margin-bottom: 2vw;
        display: flex;
        align-items: center;
        gap: 1.508vw;
        .mobileIcon{
          height: 4.444vw;
          width: 4.444vw;
        }
      }

      .input {
        position: relative;
        top: 1vw;
        width: 100%;
        height: 8.8889vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        margin-bottom: 5.277vw;

        .selectInput {
          font-family: Inter;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 21.388vw;
          height: 8.8889vw;
          text-align: center;
          color: #FFFFFF;
          font-size: 4.444vw;
          font-weight: 400;
          line-height: 10vw;
          border: 0.278vw solid #F6D9AA;
          border-radius: 1.388vw;
        }

        input {
          font-family: Inter;
          background: none;
          outline: none;
          border: 0.278vw solid #F6D9AA;
          border-radius: 1.388vw;
          height: 8.8889vw;
          width: 48.611vw;
          text-align: center;
          color: #FFFFFF;
          font-size: 4.444vw;
          font-weight: 400;
          line-height: 10vw;
          padding: 0 2vw;
        }

        .err {
          position: absolute;
          bottom: -30px;
          color: red;
          font-size: 16px;
        }
      }
    }

    .resend {
      background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
      linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
      width: 33.055vw;
      height: 10.555vw;
      border-radius: 2.222vw;
      font-size: 4.16vw;
      font-weight: 700;
      line-height: 10.555vw;
      text-align: center;
      color: #000000;
    }

    .wait {
      background: #797979;
      color: #000D2E;
      width: 33.055vw;
      height: 10.555vw;
      border-radius: 2.222vw;
      font-size: 4.16vw;
      font-weight: 700;
      line-height: 10.555vw;
      text-align: center;
    }

    .picBtn {
      width: 33.055vw;
      height: 8.8889vw;
      overflow: hidden;
      background: #BDB0B0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .btn {
      margin-top: 12vw;
      text-align: center;

      .submit {
        position: relative;
        background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
        linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        width: 85.833vw;
        height: 11.944vw;
        line-height: 11.944vw;
        border-radius: 1.388vw;
        font-size: 5vw;
        font-weight: 700;
        text-align: center;
        color: #000000;
        z-index: 1;
      }

      .disabled {
        position: relative;
        background: #797979;
        color: #000D2E;
        width: 85.833vw;
        height: 11.944vw;
        line-height: 11.944vw;
        border-radius: 1.388vw;
        font-size: 5vw;
        font-weight: 700;
        text-align: center;
        z-index: 1;
      }
    }
  }

  .inactive {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background-color: #111111;
    z-index: 9999;

    .ban {
      position: relative;
      margin-top: calc(56px + 22.222vw);
      left: 52.222%;
      transform: translate(-50%);
      width: 31.239vw;
      height: 29.444vw;

      img {
        width: 100%;
        height: 100%
      }
    }

    .close {
      position: relative;
      top: 6vw;
      width: 92vw;
      height: 3.888vw;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      img {
        width: 3.888vw;
        height: 3.888vw;
      }
    }

    .tips {
      position: relative;
      margin-top: 12vw;
      padding: 0 8vw;
      width: 100vw;
      font-size: 4.722vw;
      font-weight: 500;
      line-height: 5vw;
      text-align: left;
      color: #FFFFFF;
      letter-spacing: 0.01em;

      a {
        font-size: 4.722vw;
        font-weight: 500;
        line-height: 5.6vw;
        text-align: left;
        color: #0583F8;
        letter-spacing: 0.01em;
      }
    }

    .liveButton {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
      text-align: center;
      width: 83.661vw;
      height: 10.555vw;
      line-height: 10.555vw;
      border-radius: 1.388vw;
      font-size: 4.166vw;
      font-weight: 600;
      color: #000000;
      margin-top: 20vw;
    }
  }

  /deep/ .mint-popup-bottom {
    width: 100%;
  }

  /deep/ .picker {
    .picker-toolbar {
      background-color: #353535;

      span {
        float: right;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        line-height: 40px;
        padding-right: 10px;
      }
    }

    .picker-items {
      background-color: rgba(51, 51, 51, .9);

      .picker-item {
        color: #7b8075;
      }

      .picker-selected {
        color: #c0c0c0;
        background-color: #474747;
        width: 95%;
        margin: 0 auto;
        border-radius: 5px;
        border: none;
      }

      .picker-center-highlight {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/index.vue